<template>
  <div class="base">
    <inside-header color="#fff" title="刘冬冬的课程" />
    <div class="main">
      <div class="list">
        <div class="item">
          <div class="title-area clear">
            <div class="pull-left">
              <span class="title">初中三年级-数学提升课</span>
            </div>
            <div class="pull-right">
              <span class="status">进行中</span>
            </div>
          </div>
          <a-row class="order-info">
            <a-col :span="20" class="order-detail">
              <div class="time">
                <span class="label">授课时间</span>
                <span class="content">08-18~09-22（周六3小时）</span>
              </div>
              <div class="cycle">
                <span class="label">授课周期</span>
                <span class="content">3周</span>
              </div>
              <div class="last-teaching">
                <span class="label">下次授课</span>
                <span class="content">08-18</span>
                <span class="week">（周六）</span>
              </div>
            </a-col>
            <a-col :span="4" class="order-total">
              <span class="money">
                <span class="prefix">￥</span>
                <span class="total">258</span>
              </span>
            </a-col>
          </a-row>
          <van-divider />
          <div class="operation">
            <a-row>
              <a-col :span="12" class="info clear">
                <div class="header pull-left">
                  <img src="@/assets/test-header.png" alt="">
                </div>
                <div class="pull-left info">
                  <div class="name">
                    萧十一郎
                  </div>
                  <div class="identity">
                    授课老师
                  </div>
                </div>
              </a-col>
              <a-col :span="12" class="btn-area">
                <a-button class="goCommit">
                  去评价
                </a-button>
                <a-button class="evaluated" disabled>
                  已评价
                </a-button>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'
export default {
  name: 'TutorPay',
  components: {
    MainFooter,
    InsideHeader
  },
  data() {
    return {
    }
  },
  created() {
    // this.loadData(this.id, this.$route.query)
  },
  methods: {
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .main {
    padding: 15px;

    .list {

      .item {
        padding: 15px;
        border-radius: 10px;
        margin-bottom: 10px;
        box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);

        .title-area {

          .pull-left {
            font-family: PingFang-SC-Bold;
            font-size: 16px;
            line-height: 16px;
            font-weight: bold;
            color: #333333;
          }

          .pull-right {
            .status {
              font-family: PingFang-SC-Medium;
              font-size: 12px;
              line-height: 16px;
              color: #ff5c00;
            }
          }
        }

        .order-info {
          margin-top: 15px;

          .order-detail {

            .time, .cycle, .last-teaching {

              .label {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                line-height: 21px;
                color: #999999;
              }

              .content {
                font-size: 12px;
                color: #666666;
                margin-left: 5px;
              }

              .week {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                color: #ff5c00;
              }
            }
          }

          .order-total {
            margin-top: 10px;
            .money {
              .prefix {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                line-height: 19px;
                color: #333333;
              }

              .total {
                font-family: PingFang-SC-Medium;
                font-size: 16px;
                color: #333333;
              }
            }
          }
        }

        .operation {
          .info {

            .header {
              img {
                width: 30px;
                height: 30px;
                background-color: #e4e4e4;
              }
            }

            .info {
              margin-left: 10px;

              .name {
                font-family: PingFang-SC-Bold;
                font-size: 15px;
                line-height: 16px;
                color: #333333;
              }

              .identity {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                line-height: 16px;
                color: #999999;
              }
            }

          }

          .btn-area {
            text-align: right;

            .goCommit {
              border-radius: 15px;
              border: solid 1px $theme-color;
              color: $theme-color;
            }

            .evaluated {
              border-radius: 15px;
              border: solid 1px #ececec;
            }
          }
        }
      }
    }

  }
</style>
